import React from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import i18n from '../../../../../i18n';
import '../../../../../styles/components/preview-modal.scss';

export class PreviewModal extends React.Component {
  handleClose = () => {
    this.props.onClose();
  };

  render() {
    const { show, previewImage } = this.props;

    // Don't render modal if not shown
    if (!show) return null;

    return (
      <CustomModal isOpen={show} header={i18n.t('image_preview')} onClose={this.handleClose}>
        <div className="preview-modal-container">
          {previewImage ? (
            <div className="preview-modal-image-wrapper">
              <img src={previewImage} alt="Group preview full size" />
            </div>
          ) : (
            <div className="preview-modal-empty">
              <div className="empty-icon">
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
              </div>
              <p className="empty-text">No image available</p>
              <p className="empty-subtext">Please upload an image first</p>
            </div>
          )}
        </div>
      </CustomModal>
    );
  }
}
